import axios from "axios";
import { setupInterceptors } from "../modules/auth/services/tokenManager";
import { AUTH_API_URL } from "../constants/config";
export const authApiClient = axios.create({
  baseURL: AUTH_API_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
setupInterceptors(authApiClient, AUTH_API_URL);
